import {useTranslation} from 'react-i18next'

import {Button, DialogNew} from '@sdox/ui'
import {useCurrentOffice} from '@sdox/api'

export interface CookiePolicyContentProps {
  onClose: () => void
}

export const CookiePolicyContent = ({onClose}: CookiePolicyContentProps)  => {
  const office = useCurrentOffice()
  const cookiePolicy = office?.cookieContext.cookiePolicy?.rendered ?? ''
  const {t} = useTranslation()

  return (
    <>
      <DialogNew.Content>
        <DialogNew.StyledSection dangerouslySetInnerHTML={{__html: cookiePolicy}} />
      </DialogNew.Content>
      <DialogNew.Footer className={'flex justify-end'}>
        <Button
          variant={'outline'}
          size={'medium'}
          onClick={onClose}
        >
          {t('common:close')}
        </Button>
      </DialogNew.Footer>
    </>
  )
}
